const REDACTED = '[REDACTED]'

// Matches keys like password, token, accessToken, refresh_token, apiKey, secret, otp, pin — case-insensitive.
const SENSITIVE_KEY_PATTERN = /password|token|secret|authorization|api[-_]?key|otp|\bpin\b/i

/**
 * Recursively redacts values whose key looks sensitive (password, token, secret, ...).
 * Used as the last line of defense before data reaches Sentry (breadcrumbs, extra, contexts) —
 * request/response bodies logged via apiLogger otherwise carry plaintext credentials.
 */
export function redactSensitiveData<T>(value: T, seen: WeakSet<object> = new WeakSet()): T {
  if (value === null || typeof value !== 'object') {
    return value
  }

  if (seen.has(value)) {
    return value
  }
  seen.add(value)

  if (Array.isArray(value)) {
    const items = value as unknown[]
    const redactedArray: unknown[] = items.map((item) => redactSensitiveData(item, seen))
    return redactedArray as unknown as T
  }

  const result: Record<string, unknown> = {}
  for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
    result[key] = SENSITIVE_KEY_PATTERN.test(key) ? REDACTED : redactSensitiveData(val, seen)
  }
  return result as T
}
